export const initialSearchState = {
  searchValue: '',
  vehicleSearch: null, // { vendor, model, year, version, fitment, eanCount }
};

export const createSearchSlice = (set) => ({
  ...initialSearchState,

  setSearchValue: (value) => set({ searchValue: value }),
  setVehicleSearch: (info) => set({ vehicleSearch: info }),
  clearVehicleSearch: () => set({ vehicleSearch: null, searchValue: '' }),
});
